export default __webpack_public_path__ + "static/psoriazal-plus-sarsaparila-i-psoriazis-header-b91dd8a4d215fb625e42f42e0aaa9f48.jpg";